import axiosInstance from '../functions/axiosInstance';
import server_config from '../ServerConfiguration';

const fevir_node_server_address = server_config["fevir_node_server_address"];

const submitPmid = async (pmid = null, multiple, status, apiToken = null) => {
    if (!pmid) {
        console.log("no pmid");
        return null;
    }
    console.log("CALLING SERVER with submitpmid")
    return await axiosInstance({
        method: 'POST',
        url: fevir_node_server_address,
        timeout: 120000,
        data: {
            'functionid': 'submitpmid',
            'apiToken': apiToken,
            'tool': "medlinetofhirconverter",
            'pmid': pmid,
            'multiple': multiple,
            'status': status
        },
    }).then((resp) => {
        if (resp?.data) {
            return resp.data;
        }
        console.log("NO RESPONSE from submitpmid call");
    }).catch((error) => { console.log(error); });
};

const getPmidTitleListFromMedlineSearch = async (medlinequery = null, apiToken = null) => {
    if (!medlinequery) {
        console.log("no medlinequery");
        return null;
    }
    console.log("CALLING SERVER with importmedlinelistfromsearchquery");
    return await axiosInstance({
        method: 'POST',
        url: fevir_node_server_address,
        timeout: 120000,
        data: {
            'functionid': 'importmedlinelistfromsearchquery',
            'apiToken': apiToken,
            'medlinequery': medlinequery,
            'dontmakeproject': true
        },
    }).then((resp) => {
        if (resp?.data) {
            return resp.data;
        }
        console.log("NO RESPONSE from importmedlinelistfromsearchquery call");
    }).catch((error) => { console.log(error); });
}

const importMedlineSearch = async (medlinequery = null, apiToken = null) => {
    if (!medlinequery) {
        console.log("no medlinequery");
        return null;
    }
    console.log("CALLING SERVER with importmedlinesearchquery")
    return await axiosInstance({
        method: 'POST',
        url: fevir_node_server_address,
        timeout: 120000,
        data: {
            'functionid': 'importmedlinesearchquery',
            'apiToken': apiToken,
            'medlinequery': medlinequery,
            'dontmakeproject': true
        },
    }).then((resp) => {
        if (resp?.data) {
            return resp.data;
        }
        console.log("NO RESPONSE from importmedlinesearchquery call");
    }).catch((error) => { console.log(error); });
};

export default submitPmid;
export { importMedlineSearch, getPmidTitleListFromMedlineSearch };